import React, { useEffect, useState } from 'react'
import { useParams, useLocation, NavLink } from 'react-router-dom'
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { Alert } from '../../services/Alert';

import { useAuth } from '../../auth/useAuth';
import logo_down from '../../assets/img/download.svg';
import { Funciones } from '../../services/Funciones';

export const PricePage = () => {

    const auth = useAuth();
    const fun = Funciones();
    
    //Parametros por query
    const location = useLocation();
    
    const [state, setstate] = useState({
        cotizacion:[],
        cargado: false,
        config: JSON.parse(localStorage.getItem('config'))
    })

    const loadCotizacionList = () => {
        
        const getData = async() => {
            const config = JSON.parse(localStorage.getItem('config'));
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';

            if(AppId===''){
                //Volvemos a llamar la funcion hasta acabar
                //reloadAcuse();
                return;
            }
            
            try{
                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'GetCotizacion',
                    provider: 'proveedor',
                    data: {
                        usuario: auth.user.usuario,
                        tabla: auth.user.tabla,
                        clave: auth.user.clave
                    }
                }
                
                await axios.post(BaseUrl, data)
                .then(response => {
                    return response.data
                })
                .then(datos => {
                    
                    if((datos.type || '') === ''){
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    let listcotizacion = resultado.cotizacion || [];
                    
                    setstate({
                        ...state, 
                        cotizacion: listcotizacion, 
                        cargado: true, 
                        config: config 
                    });
                    
                }).catch(error => {
                    Alert('Error: '+error.message,'error',{});
                });
            }catch(error){
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
    }

    useEffect(() => {
        if(!state.cargado){
            loadCotizacionList();
        }
    }, [])

    return (
        <div className="container mt-5 mb-5">
            <div className='row'>
                <h1 className='m8-h2 animated fadeIn'>Cotizaciones</h1>
                <h6 className='m8-h4 animated fadeIn'>{ auth.user.descripcion }</h6>
            </div>
            <div className="row">
                <div className="mb-3 mt-3">
                    <table className="table table-bordered table-sm m8-table">
                        <thead>
                            <tr>
                                <th className='text-center'>Folio</th>
                                <th className='text-center'>Fecha</th>
                                <th className='text-center'>Vencimiento</th>
                                <th className='text-center'>Sucursal</th>
                                <th className='text-center'>Comentario</th>
                                <th className='text-center'>Productos</th>
                                <th className='text-center'>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                state.cotizacion.map(row => (
                                <tr className="m8-itext" key={row.folio}>
                                    <td><NavLink to={ "/price/" + row.folio } className="text-decoration-none m8-link m8-itext">{ row.folio }</NavLink></td>
                                    <td>{ row.fecha }</td>
                                    <td>{ row.vencimiento }</td>
                                    <td>{ row.sucursal }</td>
                                    <td>{ row.comentario }</td>
                                    <td align="center">{ fun.toNumber(row.productos,0) }</td>
                                    <td align="center">{ row.estado }</td>
                                </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="7" className=''>Total: { fun.toNumber(state.cotizacion.length) }</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
